module.exports = __webpack_public_path__ + "img/doctor-computer-TABLET.e003555e.jpg";